import { ShopifyAnalytics } from '@unlikelystudio/react-ecommerce-hooks'

import { useCookiesConsentDone } from '~/hooks/useCookiesConsentDone'

export function ShopifyAnalyticsWrapper() {
  const { cookiesConsentDone } = useCookiesConsentDone()

  return <ShopifyAnalytics hasUserConsent={cookiesConsentDone} />
}
